import { Button } from "ui/button";

import Icons from "assets";

interface StrategyLinkProps {
  label: string;
  linkLabel: string;
  href: string;
}

const StrategyLink = ({ label, linkLabel, href }: StrategyLinkProps) => (
  <div className="flex flex-col items-start w-full">
    <p className="font-bold text-base leading-6 text-gray-900">{label}</p>
    <Button
      variant="text"
      endIcon={<Icons.Forward className="size-4 shrink-0" aria-hidden="true" />}
      onClick={() => window.open(href, "_blank", "noopener,noreferrer")}>
      {linkLabel}
    </Button>
  </div>
);

export default StrategyLink;
